import cognitoAuth from "@/shared/access/CognitoAuth";
import { computed } from "vue";

export function useCognitoAuthManager() {
  const authState = cognitoAuth.getAuthState();

  const initializeAsync = async () => {
    await cognitoAuth.initializeAsync();
  };

  const AuthManager = computed(() => authState.value);

  return { AuthManager, initializeAsync };
}